import config from 'config';

export default (numberOfPanels) => (numberOfPanels > 1 ? 0 : config.deliveryPrice);
